import React, { useEffect, useState } from "react";
import { getParamsObject } from "../../../../Tools/Tools";
import AddressParams from "../../../../Sections/ElementsSections/AddressParams";
import { handleParameters } from "../../../../Tools/Requests";
import { Prefixes } from "../../../../Tools/ProjectX";
import clsx from "clsx";
import styles from "../dialogStyles.module.css";
import { PermissionFlags } from "../../../../../ComponentInterface";

interface AddressParamsProps {
  props: {
    data: any;
    selectedRecordID?: string;
    Module: Prefixes;
    kladr: boolean;
    rights?: PermissionFlags;
  };
}

/**
 * Возвращает контент для вкладки адресов
 *
 * Поля компонента:
 *    1. [addressData, setAddressData] - состояние адресов
 *
 * @param {Object} [props]
 * @param {string} [props.Module] модуль для вкладки адресов
 * @param {string} [props.data] данные для таблицы адресов
 * @param {string} [props.kladr] использование классификатора адресов
 * @param {string} [props.selectedRecordID] выбранная запись из основной таблицы
 * @param [props.rights]
 * @returns Возвращает контент для вкладки адресов
 */
export default function AddressForTabs({ props }: AddressParamsProps) {
  const { data, kladr, Module: module, selectedRecordID, rights } = props;
  const [addressData, setAddressData] = useState<any>();

  /**
   * Загрузка данных адресов
   */
  const loadAddresParams = async () => {
    if (data?.Items) {
      setAddressData(getParamsObject(data, selectedRecordID, data.Caption, module));
      return;
    }
    const res = await handleParameters(module, props, selectedRecordID);
    setAddressData(getParamsObject(res, selectedRecordID, res.Caption, module));
  };
  useEffect(() => {
    loadAddresParams();
  }, [selectedRecordID]);

  return (
    <div className={clsx(styles.fullDialogSpaceContainer)}>
      {addressData?.Items?.length && (
        <AddressParams
          Module={module}
          data={addressData}
          Token={"HandleAddress"}
          useKladr={kladr}
          readOnly={rights?.modify === false}
        />
      )}
    </div>
  );
}
